import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import UserDetails from "./pages/UserDetails";
import Servers from "./pages/Servers";
import ServerDetails from "./pages/ServerDetails";
import Clusters from "./pages/Clusters";
import ClusterDetails from "./pages/ClusterDetails";
import DoubleHops from "./pages/DoubleHops";
import DoubleHopDetails from "./pages/DoubleHopDetails";
import BulkGrant from "./pages/BulkGrant";
import Broadcast from "./pages/Broadcast";
import Broadcasts from "./pages/Broadcasts";
import Settings from "./pages/Settings";
import Operators from "./pages/Operators";
import PendingGrants from "./pages/PendingGrants";
import PromoCodes from "./pages/PromoCodes";
import Tickets from "./pages/Tickets";
import Referrals from "./pages/Referrals";
import Nodes from "./pages/Nodes";
import Endpoints from "./pages/Endpoints";
import Domains from "./pages/Domains";
import Subscriptions from "./pages/Subscriptions";
import Recurring from "./pages/Recurring";
import BotContent from "./pages/BotContent";
import Funnel from "./pages/Funnel";
import Layout from "./components/Layout";
import RequireAuth from "./components/RequireAuth";
import { PopupHost } from "./components/popup";

export default function App() {
  return (
    <>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/users" element={<Users />} />
        <Route path="/users/:id" element={<UserDetails />} />
        <Route path="/servers" element={<Servers />} />
        <Route path="/servers/:id" element={<ServerDetails />} />
        <Route path="/clusters" element={<Clusters />} />
        <Route path="/clusters/:id" element={<ClusterDetails />} />
        <Route path="/double-hops" element={<DoubleHops />} />
        <Route path="/double-hops/:id" element={<DoubleHopDetails />} />
        <Route path="/nodes" element={<Nodes />} />
        <Route path="/endpoints" element={<Endpoints />} />
        <Route path="/domains" element={<Domains />} />
        <Route path="/subscriptions" element={<Subscriptions />} />
        <Route path="/recurring" element={<Recurring />} />
        <Route path="/grants/bulk" element={<BulkGrant />} />
        <Route path="/broadcast" element={<Broadcast />} />
        <Route path="/broadcasts" element={<Broadcasts />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/bot-content" element={<BotContent />} />
        <Route path="/funnel" element={<Funnel />} />
        <Route path="/promo-codes" element={<PromoCodes />} />
        <Route path="/tickets" element={<Tickets />} />
        <Route path="/operators" element={<Operators />} />
        <Route path="/pending-grants" element={<PendingGrants />} />
        <Route path="/referrals" element={<Referrals />} />
      </Route>
    </Routes>
    <PopupHost />
    </>
  );
}
